const parseDateForInput = (date: Date) =>
  new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, -5);

export default parseDateForInput;
